import { API_URL } from '../constants';
import { postTimetableRequest } from 'src/utils/timetables/postTimetableRequest';
import { ICreateTimetableRequestBody, ITimetable } from './types';

export const createTimetables = (requestBody: ICreateTimetableRequestBody): Promise<ITimetable> =>
  postTimetableRequest<ITimetable>(`${API_URL}/timetables`, JSON.stringify(requestBody), 'Could not create timetable');
